import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack, XStack } from '@tamagui/stacks';
import { ArrowLeft } from 'lucide-react-native';
import { FONT_SIZE_3XL, FONT_SIZE_BASE, FONT_SIZE_5XL, FONT_SIZE_4XL, FONT_SIZE_MD, ICON_SIZE } from '../constants';

export type WalletHeaderProps = {
  isDark: boolean;
  textColor: string;
  onBack: () => void;
};

const WalletHeader: React.FC<WalletHeaderProps> = React.memo(({ isDark, textColor, onBack }) => {
  return (
    <YStack width="100%" space="$4">
      {/* Header */}
      <XStack
        paddingTop="$10"
        paddingHorizontal="$4"
        alignItems="center"
        space="$3"
        width="100%"
      >
        <TouchableOpacity onPress={onBack}>
          <ArrowLeft size={ICON_SIZE} color="white" />
        </TouchableOpacity>
        <Text
          fontSize={FONT_SIZE_3XL}
          fontWeight="bold"
          color="white"
          fontFamily="Poppins"
          numberOfLines={1}
          adjustsFontSizeToFit
          minimumFontScale={0.8}
          flexShrink={1}
        >
          Portfel
        </Text>
      </XStack>

      {/* Balance Section */}
      <YStack paddingHorizontal="$4" paddingTop="$2" alignItems="center">
        <Text fontSize={FONT_SIZE_BASE} color="rgba(255, 255, 255, 0.8)" fontWeight="500">
          Dostępne środki
        </Text>
        <Text fontSize={FONT_SIZE_5XL} color="white" fontWeight="bold" marginTop="$2">
         1 500 zł
        </Text>
      </YStack>

      {/* Statistics */}
      <XStack paddingHorizontal="$4" paddingTop="$4" paddingBottom="$1" justifyContent="space-between" alignItems="flex-end">
        {/* Received Gifts - Left */}
        <YStack alignItems="center">
          <Text fontSize={FONT_SIZE_4XL} color="white" fontWeight="bold">
            8
          </Text>
          <Text fontSize={FONT_SIZE_MD} color="rgba(255, 255, 255, 0.8)" marginTop="$1" textAlign="center">
            Otrzymanych prezentów
          </Text>
        </YStack>

        {/* Meetings This Month - Right */}
        <YStack alignItems="center">
          <Text fontSize={FONT_SIZE_4XL} color="white" fontWeight="bold">
            7
          </Text>
          <Text fontSize={FONT_SIZE_MD} color="rgba(255, 255, 255, 0.8)" marginTop="$1" textAlign="center">
            Spotkań w tym miesiącu
          </Text>
        </YStack>
      </XStack>
    </YStack>
  );
});

WalletHeader.displayName = 'WalletHeader';

export default WalletHeader;

